import { render, staticRenderFns } from "./CustomerParametersList.vue?vue&type=template&id=5ccb3870"
import script from "./CustomerParametersList.vue?vue&type=script&lang=js"
export * from "./CustomerParametersList.vue?vue&type=script&lang=js"
import style0 from "./CustomerParametersList.vue?vue&type=style&index=0&id=5ccb3870&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports